module.exports = __webpack_public_path__ + "media/app/assets/races/kul_tiran_male-b80af16ea612ab389c35045ea429707a.png";